import { ILayoutsCatalog, ILayoutsCatalogState, TLayoutByIdMap } from '../../types/layouts/layoutsCatalog';

type TRedusedLayoutsCatalog = {
  layoutsIds: number[];
  layoutsById: TLayoutByIdMap;
};

export const layoutsStateMapper = (response: ILayoutsCatalog): ILayoutsCatalogState => {
  const mappedLayouts = response.newbuildingLayouts.reduce<TRedusedLayoutsCatalog>(
    (acc, layout) => {
      acc.layoutsIds.push(layout.id);
      acc.layoutsById[layout.id] = layout;

      return acc;
    },
    {
      layoutsIds: [],
      layoutsById: {},
    },
  );

  return {
    seo: response.seo,
    pagination: response.pagination,
    layoutsIds: mappedLayouts.layoutsIds,
    layoutsById: mappedLayouts.layoutsById,
  };
};
